import { Pipe, PipeTransform } from '@angular/core';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'expenseBillable'
})
export class ExpenseBillablePipe implements PipeTransform {
  public transform(departmentEstimate: DepartmentEstimate): number {
    let cost = 0;

    for (const estimateLine of departmentEstimate.estimateLines) {
      if (estimateLine.expenseLine) {
        cost = estimateLine.expenseLine.amountBillable;
      }
    }

    return cost;
  }
}
